import { SERVER_API } from "../../Constant";

export const CustomReportQuery_api = async (
  module: string,
  joins: string[],
  filters: any[],
  columns: string[],
  orderBy: string = "",
  orderDir: string = "DESC",
  limit: number = 1000,
  groupBy: string = "",
  aggregate: any = null,
) => {
  try {
    const response = await fetch(
      `${SERVER_API}/Reports/custom_report_query.php`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ module, joins, filters, columns, orderBy, orderDir, limit, groupBy, aggregate }),
      },
    );
    return await response.json();
  } catch (error) {
    console.error("Error in CustomReportQuery_api:", error);
    return { success: false, msg: "Network error" };
  }
};

export const SaveReportTemplate_api = async (
  name: string,
  module: string,
  configuration: any,
  userId: string | null,
  chatHistory: any[] | null = null,
) => {
  try {
    const response = await fetch(
      `${SERVER_API}/Reports/save_report_template.php`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name, module, configuration, userId, chat_history: chatHistory }),
      },
    );
    return await response.json();
  } catch (error) {
    console.error("Error in SaveReportTemplate_api:", error);
    return { success: false, msg: "Network error" };
  }
};

export const FetchReportTemplates_api = async () => {
  try {
    const response = await fetch(
      `${SERVER_API}/Reports/fetch_report_templates.php`,
      {
        method: "GET",
      },
    );
    return await response.json();
  } catch (error) {
    console.error("Error in FetchReportTemplates_api:", error);
    return { success: false, msg: "Network error" };
  }
};

export const DeleteReportTemplate_api = async (id: number) => {
  try {
    const response = await fetch(
      `${SERVER_API}/Reports/delete_report_template.php`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id }),
      },
    );
    return await response.json();
  } catch (error) {
    console.error("Error in DeleteReportTemplate_api:", error);
    return { success: false, msg: "Network error" };
  }
};

export const UpdateReportTemplate_api = async (
  id: number,
  name: string,
  module: string,
  configuration: any,
  chatHistory: any[] | null = null,
) => {
  try {
    const response = await fetch(
      `${SERVER_API}/Reports/update_report_template.php`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, name, module, configuration, chat_history: chatHistory }),
      },
    );
    return await response.json();
  } catch (error) {
    console.error("Error in UpdateReportTemplate_api:", error);
    return { success: false, msg: "Network error" };
  }
};

